<template>
  <!-- Modal -->
  <div>
    <v-select placeholder="Select Location Tag" :options="allTags" label="name" name="locationtag" v-model="locationtag"></v-select>
    <br>
    <form-text ref="speaktext" label="Speak Text" name="speaktext" v-model="speak" validation="required"></form-text>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import FormText from '../../../elements/Form/FormText'
import database from '../../../webmaster/Database/database'

export default {
  name: 'locationtagtask',
  components:{
    vSelect,
    'form-text': FormText
  },
  data() {
    return {
      locationtag: '',
      speak: 'Check Completed',
      allTags: []
    }
  },
  created:function(){
    //Populate users
    var ref = '/orgs/' + this.$store.state.usermain.curOrg.id + '/devices'
    this.$bindAsArray('allTags', database.getRef(ref).orderByChild('type').equalTo('Location Tag'));
  },
}
</script>


// WEBPACK FOOTER //
// LocationTag.vue?412d0c6a